<template>
  <div class="app-container">
    <div class="filter-container" style="display: flex;flex-wrap: wrap;">
      <el-input class="filter-item" v-model="listQuery.outer_order_id" placeholder="请输入订单编号" style="width: 220px;" clearable/>

      <el-input class="filter-item" v-model="listQuery.customer_name" placeholder="请输入收件人" style="width: 220px;" clearable/>

      <el-input class="filter-item" v-model="listQuery.customer_phone" placeholder="请输入收件人电话" style="width: 220px;" clearable/>

      <el-select class="filter-item" v-model="listQuery.inflow_status" placeholder="请选择流入状态" style="width: 160px" clearable>
        <el-option label="无需流入" :value="0"></el-option>
        <el-option label="流入待扣费" :value="1"></el-option>
        <el-option label="流入扣费成功" :value="2"></el-option>
      </el-select>

      <el-select class="filter-item" v-model="listQuery.error_status" placeholder="请选择异常状态" style="width: 160px" clearable>
        <el-option label="正常" :value="0"></el-option>
        <el-option label="站长余额不足" :value="1"></el-option>
        <el-option label="匹配不到短信号码" :value="2"></el-option>
      </el-select>

      <el-select class="filter-item" v-model="listQuery.order_status" placeholder="请选择订单状态" style="width: 160px" clearable>
        <el-option label="待收餐" :value="0"></el-option>
        <el-option label="已收餐" :value="1"></el-option>
        <el-option label="已分拣" :value="2"></el-option>
        <el-option label="配送中" :value="3"></el-option>
        <el-option label="已完成" :value="4"></el-option>
        <el-option label="已退款" :value="5"></el-option>
      </el-select>

      <el-date-picker v-model="dateArr" type="daterange" value-format="yyyy-MM-dd" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" class="filter-item" style="display: flex;" clearable></el-date-picker>

      <el-button class="filter-item" type="primary" @click="handleFilter">搜索</el-button>
    </div>

    <el-table v-loading="listLoading" :data="list" element-loading-text="Loading" fit highlight-current-row>
      <el-table-column label="ID" width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>

      <el-table-column label="站长" min-width="110" align="center">
        <template slot-scope="scope">
          <div style="display: flex;flex-direction:column;align-items:center;text-align:center;" v-if="scope.row.stationmaster">
            <img :src="scope.row.stationmaster.avatar" style="width: 26px;height:26px;border-radius:4px;margin-right:4px;">
            <span>{{ scope.row.stationmaster.name }}</span>
            <span>{{ scope.row.stationmaster.phone }}</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="订单平台" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.source }}
        </template>
      </el-table-column>

      <el-table-column label="订单编号" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.outer_order_id }}
        </template>
      </el-table-column>

      <el-table-column label="店铺名称" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.shop_name }}
        </template>
      </el-table-column>

      <el-table-column label="订单流水号" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.day_seq }}
        </template>
      </el-table-column>

      <el-table-column label="收件人" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.customer_name }}
        </template>
      </el-table-column>

      <el-table-column label="收件人电话" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.customer_phone }}
        </template>
      </el-table-column>

      <el-table-column label="收件地址" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.address }}
        </template>
      </el-table-column>

      <el-table-column label="备注" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.remark }}
        </template>
      </el-table-column>

      <el-table-column label="是否预订单" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_schedule === 0" type="danger">否</el-tag>
          <el-tag v-else-if="scope.row.is_schedule === 1" type="success">是</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="预计送达时间" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.delivery_time }}
        </template>
      </el-table-column>

      <el-table-column label="下单时间" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_time }}
        </template>
      </el-table-column>

      <el-table-column label="流入状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.inflow_status === 0" type="info">无需流入</el-tag>
          <el-tag v-else-if="scope.row.inflow_status === 1" type="warning">流入待扣费</el-tag>
          <el-tag v-else-if="scope.row.inflow_status === 2" type="success">流入扣费成功</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="流入费用" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.inflow_fee }}
        </template>
      </el-table-column>

      <el-table-column label="异常状态" min-width="130" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.error_status === 0" type="success">正常</el-tag>
          <el-tag v-else-if="scope.row.error_status === 1" type="danger">站长余额不足</el-tag>
          <el-tag v-else-if="scope.row.error_status === 2" type="danger">匹配不到短信号码</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="订单状态" min-width="130" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.order_status === 0" type="info">待收餐</el-tag>
          <el-tag v-else-if="scope.row.order_status === 1" type="primary">已收餐</el-tag>
          <el-tag v-else-if="scope.row.order_status === 2" type="warning">已分拣</el-tag>
          <el-tag v-else-if="scope.row.order_status === 3" type="success">配送中</el-tag>
          <el-tag v-else-if="scope.row.order_status === 4" type="success">已完成</el-tag>
          <el-tag v-else-if="scope.row.order_status === 5" type="danger">已退款</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="退款原因" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.refund_reason }}
        </template>
      </el-table-column>

      <el-table-column label="收餐员" min-width="110" align="center">
        <template slot-scope="scope">
          <div style="display: flex;flex-direction:column;align-items:center;text-align:center;" v-if="scope.row.meal_personnel && scope.row.meal_personnel.user">
            <img :src="scope.row.meal_personnel.user.avatar" style="width: 26px;height:26px;border-radius:4px;margin-right:4px;">
            <span>{{ scope.row.meal_personnel.user.name }}</span>
            <span>{{ scope.row.meal_personnel.user.phone }}</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="收餐时间" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.meal_time }}
        </template>
      </el-table-column>

      <el-table-column label="分拣员" min-width="110" align="center">
        <template slot-scope="scope">
          <div style="display: flex;flex-direction:column;align-items:center;text-align:center;" v-if="scope.row.distribute_personnel && scope.row.distribute_personnel.user">
            <img :src="scope.row.distribute_personnel.user.avatar" style="width: 26px;height:26px;border-radius:4px;margin-right:4px;">
            <span>{{ scope.row.distribute_personnel.user.name }}</span>
            <span>{{ scope.row.distribute_personnel.user.phone }}</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="分拣时间" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.distribute_time }}
        </template>
      </el-table-column>

      <el-table-column label="出餐超时状态" min-width="130" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.cooking_timeout_status === 0" type="info">待处理</el-tag>
          <el-tag v-else-if="scope.row.cooking_timeout_status === 1" type="success">未超时</el-tag>
          <el-tag v-else-if="scope.row.cooking_timeout_status === 2" type="danger">已超时</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="配送员" min-width="110" align="center">
        <template slot-scope="scope">
          <div style="display: flex;flex-direction:column;align-items:center;text-align:center;" v-if="scope.row.send_personnel && scope.row.send_personnel.user">
            <img :src="scope.row.send_personnel.user.avatar" style="width: 26px;height:26px;border-radius:4px;margin-right:4px;">
            <span>{{ scope.row.send_personnel.user.name }}</span>
            <span>{{ scope.row.send_personnel.user.phone }}</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="配送时间" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.send_time }}
        </template>
      </el-table-column>

      <el-table-column label="配送超时状态" min-width="130" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.send_timeout_status === 0" type="info">待处理</el-tag>
          <el-tag v-else-if="scope.row.send_timeout_status === 1" type="success">未超时</el-tag>
          <el-tag v-else-if="scope.row.send_timeout_status === 2" type="danger">已超时</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="配送凭证" min-width="110" align="center">
        <template slot-scope="scope">
          <img :src="scope.row.send_image" style="width: 90px;height:90px;border-radius:4px;" v-if="scope.row.send_image">
        </template>
      </el-table-column>

      <el-table-column label="发送短信号码" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.sms_phone }}
        </template>
      </el-table-column>

      <el-table-column label="发送短信内容" min-width="110" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.takeout_sideboard_order">
            {{ scope.row.takeout_sideboard_order.device_name }}-{{ scope.row.takeout_sideboard_order.cell_alias }} 取件码{{ scope.row.takeout_sideboard_order.take_code }}
          </div>
          <div v-else>
            {{ scope.row.sms_content }}
          </div>
        </template>
      </el-table-column>

      <el-table-column label="发送短信状态" min-width="110" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.takeout_sideboard_order">
            <el-tag type="info" v-if="scope.row.takeout_sideboard_order.sms_status === 0">未发送</el-tag>
            <el-tag type="success" v-else-if="scope.row.takeout_sideboard_order.sms_status === 1">发送成功</el-tag>
            <el-tag type="danger" v-else-if="scope.row.takeout_sideboard_order.sms_status === 2">发送失败</el-tag>
          </div>
          <div v-else>
            <el-tag type="info" v-if="scope.row.sms_status === 0">未发送</el-tag>
            <el-tag type="success" v-else-if="scope.row.sms_status === 1">发送成功</el-tag>
            <el-tag type="danger" v-else-if="scope.row.sms_status === 2">发送失败</el-tag>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="短信接收状态" min-width="110" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.takeout_sideboard_order">
            <el-tag type="success" v-if="scope.row.takeout_sideboard_order.sms_receive_status === 'DELIVRD'">成功</el-tag>
            <el-tag type="danger" v-else-if="scope.row.takeout_sideboard_order.sms_receive_status">{{ scope.row.sms_receive_status }}</el-tag>
          </div>
          <div v-else>
            <el-tag type="success" v-if="scope.row.sms_receive_status === 'DELIVRD'">成功</el-tag>
            <el-tag type="danger" v-else-if="scope.row.sms_receive_status">{{ scope.row.sms_receive_status }}</el-tag>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="点达员" min-width="110" align="center">
        <template slot-scope="scope">
          <div style="display: flex;flex-direction:column;align-items:center;text-align:center;" v-if="scope.row.delivery_personnel && scope.row.delivery_personnel.user">
            <img :src="scope.row.delivery_personnel.user.avatar" style="width: 26px;height:26px;border-radius:4px;margin-right:4px;">
            <span>{{ scope.row.delivery_personnel.user.name }}</span>
            <span>{{ scope.row.delivery_personnel.user.phone }}</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="点达分配时间" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.delivery_distribute_time }}
        </template>
      </el-table-column>

      <el-table-column label="点达完成时间" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.delivery_complete_time }}
        </template>
      </el-table-column>

      <el-table-column label="操作" width="200" align="center" fixed="right" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button type="warning" size="mini" @click="handleBindSmsPhone(scope.row)" :disabled="!!scope.row.sms_phone">绑定短信号码</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination :current-page="listQuery.page" :page-sizes="[5,10,20,30,50]" :page-size="listQuery.limit" :total="total" background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>

    <!-- 绑定短信号码 -->
    <el-dialog title="绑定短信号码" :visible.sync="dialogVisibleBindSmsPhone" width="60%" :close-on-click-modal="false">
      <el-form ref="bindSmsPhoneForm" :rules="bindSmsPhoneRules" :model="bindSmsPhoneForm" label-width="150px">
        <el-form-item label="短信号码" prop="sms_phone">
          <el-input v-model="bindSmsPhoneForm.sms_phone"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleBindSmsPhone = false">取消</el-button>
        <el-button type="primary" @click="saveDataBindSmsPhone" :loading="btnLoading">确定</el-button>
      </div>
    </el-dialog>
    <!-- 绑定短信号码 -->
  </div>
</template>

<script>
  import request from "@/utils/request";
  import { mapGetters } from "vuex";

  export default {
    data() {
      return {
        list: null,
        total: null,
        listLoading: true,
        listQuery: {
          page: 1,
          limit: 10,
          school_id: "",
          outer_order_id: "",
          customer_name: "",
          customer_phone: "",
          inflow_status: "",
          error_status: "",
          order_status: "",
          start_date: "",
          end_date: "",
        },
        dateArr: null,
        // 绑定短信号码
        dialogVisibleBindSmsPhone: false,
        btnLoading: false,
        bindSmsPhoneForm: {
          outer_order_id: "",
          sms_phone: "",
        },
        bindSmsPhoneRules: {
          sms_phone: [{ required: true, message: "短信号码不能为空", trigger: "change" }],
        },
      };
    },
    created() {
      this.getList();
    },
    computed: {
      ...mapGetters(["schools","school_id","user"])
    },
    watch: {
      school_id(newVal, oldVal) {
        this.listQuery.school_id = newVal;
        this.getList();
      },
      dateArr(newVal, oldVal) {
        if (newVal) {
          this.listQuery.start_date = newVal[0];
          this.listQuery.end_date = newVal[1];
        } else {
          this.listQuery.start_date = "";
          this.listQuery.end_date = "";
        }
      }
    },
    methods: {
      getList() {
        this.listQuery.school_id = this.school_id;
        this.listLoading = true;
        request({
          url: "/api/backend/takeoutOrder/list",
          method: "get",
          params: this.listQuery,
        }).then(response => {
          this.list = response.data.data;
          this.total = response.data.total;
          this.listLoading = false;
        });
      },
      handleFilter() {
        this.listQuery.page = 1;
        this.getList();
      },
      handleSizeChange(val) {
        this.listQuery.limit = val;
        this.getList();
      },
      handleCurrentChange(val) {
        this.listQuery.page = val;
        this.getList();
      },
      // 下载发票
      handleDownloadInvoice(invoiceImage) {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        const image = new Image();
        image.crossOrigin = "Anonymous";
        image.src = invoiceImage;
        image.onload = () => {
          canvas.width = image.width;
          canvas.height = image.height;
          ctx.drawImage(image, 0, 0);
          const imageUrl = canvas.toDataURL("image/png");
          const link = document.createElement("a");
          link.href = imageUrl;
          link.download = "downloaded-image.png";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        };
      },
      // 绑定短信号码
      handleBindSmsPhone(row) {
        this.bindSmsPhoneForm = {
          outer_order_id: row.outer_order_id,
          sms_phone: "",
        };
        this.dialogVisibleBindSmsPhone = true;
        this.$nextTick(() => {
          this.$refs["bindSmsPhoneForm"].clearValidate() //清除校验结果
        })
      },
      saveDataBindSmsPhone() {
        this.$refs["bindSmsPhoneForm"].validate((valid) => {
          if (valid) {
            this.btnLoading = true;
            request({
              url: "/api/backend/takeoutOrder/bindSmsPhone",
              method: "post",
              data: this.bindSmsPhoneForm,
            }).then(() => {
              this.dialogVisibleBindSmsPhone = false;
              this.$message({
                type: "success",
                message: "操作成功"
              });
              this.getList();
            }).finally(() => {
              this.btnLoading = false;
            });
          }
        });
      },
    }
  };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .user-avatar {
    width: 40px;
    height: 40px;
    border-radius: 6px;
  }
</style>
